import React from 'react';
import PropTypes from 'prop-types';

export const DataLoadingWrapper = ({ children }) => <div className="placeholder-loading">{children}</div>;

DataLoadingWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
